import { Group } from '@qred/components-library';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { RootState } from '~/store';
import {
  setBeneficialOwners,
  updateForm,
} from '~/store/slices/cardOffer.slice';
import { useCardOfferSelectors } from '~/store/selectors/cardOffer.selector';
import { isBeneficialOwner } from '~/helpers/shared.helper';
import AdditionalOwner from './AdditionalOwner';

const OwnersList = () => {
  const dispatch = useAppDispatch();
  const { owners, companyHasOtherBeneficialOwners, applicant } = useSelector(
    (state: RootState) => state.cardOffer.form
  );

  const {
    applicantIsABeneficialOwner,
    applicantIsSoloBeneficialOwner,
  } = useCardOfferSelectors();

  useEffect(() => {
    if (owners.length) {
      const shouldResetOwnersList =
        (applicantIsABeneficialOwner && !companyHasOtherBeneficialOwners) ||
        applicantIsSoloBeneficialOwner;

      if (applicantIsSoloBeneficialOwner) {
        dispatch(
          updateForm({
            companyHasOtherBeneficialOwners: false,
          })
        );
      }

      if (shouldResetOwnersList) {
        dispatch(setBeneficialOwners([]));
      } else {
        dispatch(
          setBeneficialOwners(
            owners.filter((owner) =>
              companyHasOtherBeneficialOwners
                ? isBeneficialOwner(owner.percentage)
                : !isBeneficialOwner(owner.percentage)
            )
          )
        );
      }
    }
  }, [
    companyHasOtherBeneficialOwners,
    applicant.percentage,
    applicantIsABeneficialOwner,
    applicantIsSoloBeneficialOwner,
  ]);

  return (
    <Group direction="column" spacing="sm">
      {owners.map((owner) => (
        <AdditionalOwner owner={owner} key={owner.id} />
      ))}
    </Group>
  );
};

export default OwnersList;
